module.exports = __webpack_public_path__ + "img/error.1519a0ff.png";